/**
 * フォーム関係-JSONで設定されているformRemarks（項目の説明）を表示するコンポーネント
 */
import React, { useEffect, useRef, useContext } from "react";

import { makeStyles } from "@material-ui/core";

import { FONT } from "../../../../constants/common";

import LineBreaksText from "../../../common/components/atoms/LineBreaksText";
import terms from "../../../../api/terms";
import { AuthContext } from "../../../../cognito/AuthContext";
import { GlobalPopupContext } from "../../../../App";
import getErrorMessage from "../../../../utils/error";

const useStyles = makeStyles(() => ({
  remark: {
    color: "#777",
    fontFamily: FONT,
  },
}));

type Props = {
  remarks: string;
  allowHtml?: boolean;
};

const FormRemarks: React.FC<Props> = (props: Props) => {
  const { remarks, allowHtml } = props;

  const classes = useStyles();
  const ref = useRef<HTMLDivElement>(null);
  const { authHeader } = useContext(AuthContext) || {};
  const { setSnackbar } = useContext(GlobalPopupContext) || {};

  useEffect(() => {
    if (allowHtml && ref.current) {
      const links = ref.current.querySelectorAll(
        "a#terms-link[data-terms-number]"
      );
      links.forEach((link) => {
        link.replaceWith(link.cloneNode(true));
      });
      const updatedLinks = ref.current.querySelectorAll(
        "a#terms-link[data-terms-number]"
      );
      updatedLinks.forEach((link) => {
        link.addEventListener("click", async (e) => {
          e.preventDefault();
          const termsNumber = link.getAttribute("data-terms-number");
          if (!termsNumber) return;
          try {
            const res = await terms.get(
              authHeader as string,
              Number(termsNumber)
            );
            const pdf = res.data.result.pdfData;
            const blob = new Blob(
              [Uint8Array.from(atob(pdf), (c) => c.charCodeAt(0))],
              { type: "application/pdf" }
            );
            const url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");
          } catch (error) {
            if (setSnackbar) {
              setSnackbar({
                openProps: true,
                severity: "error",
                message: getErrorMessage(error),
              });
            }
          }
        });
      });
    }
  }, [allowHtml, remarks, authHeader, setSnackbar]);

  if (allowHtml) {
    const htmlWithBr = remarks.replace(/\n/g, "<br />");
    return (
      <div
        ref={ref}
        className={classes.remark}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: htmlWithBr }}
      />
    );
  }
  return (
    <div className={classes.remark}>
      <LineBreaksText text={remarks} />
    </div>
  );
};

export default FormRemarks;
